// texte traduse: window.CF_I18N vine din snippets/i18n-js.liquid (cheile js.* din locales);
// dacă lipsește o cheie, rămâne textul românesc. {nume} se înlocuiește cu valoarea din vars.
var CF_T = function(key, fallback, vars){
  var all = window.CF_I18N || {}, s = typeof all[key] === 'string' ? all[key] : fallback;
  if (vars) for (var k in vars) s = s.split('{' + k + '}').join(vars[k]);
  return s;
};

(function(){
  // rotating promo bar
  var msgs = document.querySelectorAll('#promo .msg'), pi = 0;
  if (msgs.length > 1) {
    setInterval(function(){
      msgs[pi].classList.remove('on');
      pi = (pi + 1) % msgs.length;
      msgs[pi].classList.add('on');
    }, 3800);
  }

  // hero slider
  var track = document.getElementById('htrack');
  if (track && track.children.length > 1) {
    var slides = track.children.length, hi = 0,
        dotsC = document.getElementById('hdots'), hero = document.getElementById('hero');
    for (var i = 0; i < slides; i++) {
      (function(i){
        var d = document.createElement('button');
        if (i === 0) d.className = 'on';
        d.setAttribute('aria-label', CF_T('hero_slide', 'Slide {n}', { n: i + 1 }));
        d.addEventListener('click', function(){ go(i); });
        dotsC.appendChild(d);
      })(i);
    }
    var dots = dotsC.children;
    function go(n){
      hi = (n + slides) % slides;
      track.style.transform = 'translateX(-' + (hi * 100) + '%)';
      for (var i = 0; i < dots.length; i++){ dots[i].className = (i === hi ? 'on' : ''); }
    }
    track.addEventListener('focusin', function(e){ var s = e.target.closest('.hslide'); if (!s) return; hero.scrollLeft = 0; go(Array.prototype.indexOf.call(track.children, s)); });
    var nx = document.getElementById('hnext'), pv = document.getElementById('hprev');
    if (nx) nx.addEventListener('click', function(){ go(hi + 1); });
    if (pv) pv.addEventListener('click', function(){ go(hi - 1); });
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches, timer;
    function play(){ if (reduce) return; timer = setInterval(function(){ go(hi + 1); }, 5500); }
    function stop(){ clearInterval(timer); }
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', play);
    play();
  }
})();

// căutare cu sugestii pe loc (Shopify predictive search: /search/suggest.json)
(function(){
  var form = document.getElementById('hsearch'), input = document.getElementById('hq'),
      box = document.getElementById('psug'), status = document.getElementById('psugStatus'),
      mbtn = document.getElementById('msearch');
  if (!form || !input || !box) return;
  var api = form.getAttribute('data-suggest') + '.json',
      timer, ctrl, opts = [], active = -1, last = '';

  // telefon: lupa din header deschide căsuța de căutare
  if (mbtn) mbtn.addEventListener('click', function(e){
    e.stopPropagation();
    var on = form.classList.toggle('open');
    mbtn.setAttribute('aria-expanded', on ? 'true' : 'false');
    if (on) input.focus(); else close();
  });

  function el(tag, cls, text){ var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function lei(v){ var n = Number(v); return isNaN(n) ? '' : CF_T('search_price', '{amount} lei', { amount: n.toLocaleString(document.documentElement.lang || 'ro', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }); }
  function thumb(src){ return src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=120' : ''; }
  function searchUrl(q){ return form.getAttribute('action') + '?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last'; }
  function img(src){
    if (!src) return el('span', 'ph');
    var i = el('img'); i.src = thumb(src); i.alt = ''; i.width = 48; i.height = 48; i.loading = 'lazy'; return i;
  }

  function open(){ box.hidden = false; input.setAttribute('aria-expanded', 'true'); }
  function close(){ box.hidden = true; input.setAttribute('aria-expanded', 'false'); setActive(-1); }
  function setActive(n){
    if (active > -1 && opts[active]) opts[active].classList.remove('on');
    active = n;
    if (n > -1) { opts[n].classList.add('on'); input.setAttribute('aria-activedescendant', opts[n].id); opts[n].scrollIntoView({ block: 'nearest' }); }
    else input.removeAttribute('aria-activedescendant');
  }

  function render(q, r){
    box.textContent = ''; opts = []; active = -1; input.removeAttribute('aria-activedescendant');
    var lq = q.toLowerCase(),
        prods = (r.products || []).slice(0, 6),
        cols = (r.collections || []).slice(0, 3),
        arts = (r.articles || []).slice(0, 2),
        qs = (r.queries || []).filter(function(x){ return x.text && x.text.toLowerCase() !== lq; }).slice(0, 3);
    function add(a){ a.setAttribute('role', 'option'); a.id = 'pso' + opts.length; a.tabIndex = -1; opts.push(a); return a; }
    function group(label, items, make){
      if (!items.length) return;
      var g = el('div', 'psg'); g.setAttribute('role', 'group'); g.setAttribute('aria-label', label);
      var h = el('div', 'psh', label); h.setAttribute('aria-hidden', 'true'); g.appendChild(h);
      items.forEach(function(it){ g.appendChild(add(make(it))); });
      box.appendChild(g);
    }
    group(CF_T('search_popular', 'Căutări populare'), qs, function(x){ var a = el('a', 'psq', x.text); a.href = searchUrl(x.text); return a; });
    group(CF_T('search_products', 'Produse'), prods, function(p){
      var a = el('a', 'psp'); a.href = p.url;
      // produsele explicite (tag „explicit”) nu arată poza în sugestii
      var expl = (p.tags || []).some(function(t){ return String(t).toLowerCase() === 'explicit'; });
      a.appendChild(img(expl ? '' : ((p.featured_image && p.featured_image.url) || p.image)));
      var t = el('span', 'pst'); t.appendChild(el('span', 'psn', p.title));
      var min = p.price_min || p.price, pr = el('span', 'psr tnum', p.price_max && Number(p.price_max) > Number(min) ? CF_T('search_from_price', 'de la {price}', { price: lei(min) }) : lei(min));
      if (form.getAttribute('data-old') === '1' && Number(p.compare_at_price_min) > Number(min)) { pr.appendChild(document.createTextNode(' ')); pr.appendChild(el('s', '', lei(p.compare_at_price_min))); }
      if (p.available === false) pr.appendChild(el('span', 'psna', ' · ' + CF_T('search_sold_out', 'stoc epuizat')));
      t.appendChild(pr); a.appendChild(t);
      return a;
    });
    group(CF_T('search_collections', 'Categorii'), cols, function(c){ var a = el('a', 'psl', c.title); a.href = c.url; return a; });
    group(CF_T('search_articles', 'Ghiduri'), arts, function(g){ var a = el('a', 'psl', g.title); a.href = g.url; return a; });
    var any = prods.length + cols.length + arts.length + qs.length;
    var all = el('a', 'psall', prods.length ? CF_T('search_view_all', 'Vezi toate rezultatele pentru „{q}”', { q: q }) : (any ? CF_T('search_for', 'Caută „{q}” printre produse', { q: q }) : CF_T('search_none_for', 'Nicio sugestie. Caută „{q}” printre produse', { q: q })));
    all.href = searchUrl(q);
    box.appendChild(add(all));
    if (status) status.textContent = prods.length
      ? (prods.length === 1 ? CF_T('search_products_one', '{count} produs găsit', { count: 1 }) : CF_T('search_products_other', '{count} produse găsite', { count: prods.length }))
      : (any ? (any === 1 ? CF_T('search_suggestions_one', '{count} sugestie', { count: 1 }) : CF_T('search_suggestions_other', '{count} sugestii', { count: any })) : CF_T('search_no_suggestions', 'Nicio sugestie'));
    open();
  }

  function suggest(q){
    if (q === last && opts.length) { open(); return; }
    last = q;
    if (ctrl) ctrl.abort();
    ctrl = window.AbortController ? new AbortController() : null;
    var ps = new URLSearchParams({
      q: q,
      'resources[type]': 'product,collection,article,query',
      'resources[limit]': '6',
      'resources[limit_scope]': 'each',
      'resources[options][unavailable_products]': 'last',
      'resources[options][fields]': 'title,product_type,variants.title,vendor,tag'
    });
    fetch(api + '?' + ps.toString(), { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: 'application/json' } })
      .then(function(res){ if (!res.ok) throw new Error(res.status); return res.json(); })
      .then(function(d){ if (input.value.trim() === q) render(q, (d.resources && d.resources.results) || {}); else last = ''; })
      .catch(function(err){ if (err && err.name === 'AbortError') return; last = ''; if (input.value.trim() === q) render(q, {}); });
  }

  input.addEventListener('input', function(){
    clearTimeout(timer);
    var q = input.value.trim();
    if (q.length < 2) { if (ctrl) ctrl.abort(); last = ''; opts = []; box.textContent = ''; close(); return; }
    timer = setTimeout(function(){ suggest(q); }, 180);
  });
  function reopen(){ if (opts.length && input.value.trim() === last) open(); }
  input.addEventListener('focus', reopen);
  input.addEventListener('click', reopen);
  input.addEventListener('keydown', function(e){
    if (e.key === 'Escape') { if (!box.hidden) { e.preventDefault(); close(); } return; }
    if (box.hidden || !opts.length) return;
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      var n = active + (e.key === 'ArrowDown' ? 1 : -1);
      setActive(n < -1 ? opts.length - 1 : n >= opts.length ? -1 : n);
    } else if (e.key === 'Enter' && active > -1) {
      e.preventDefault();
      location.href = opts[active].href;
    }
  });
  // un clic pe sugestie nu trebuie să mute focusul (altfel lista se închide înainte să se deschidă linkul)
  box.addEventListener('mousedown', function(e){ e.preventDefault(); });
  form.addEventListener('focusout', function(e){ if (e.relatedTarget && !form.contains(e.relatedTarget)) close(); });
  document.addEventListener('click', function(e){ if (!form.contains(e.target)) close(); });
})();
